import _ from '@lodash';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Dialog } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import useToast from '@fuse/hooks/useToast';
import axios from "@fuse/utils/axios";
import Tooltip from '@material-ui/core/Tooltip';
import AlphabeticalSorting from '@fuse/utils/alphabeticalSort';
import 'ag-grid-enterprise';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import ActivityAgGridListing from '@fuse/components/ActivitieLogs/activitiesAgGridListing';
// import CustomDropdownEditor from '@fuse/components/AgGridFilterGroupView/components/CustomDropdownEditor';
import DeleteConfirmModal from 'helper/DeleteConfirm';
import { openReportViewerDialog, setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import { openFormViewerDialog, setFromData } from '../store/formViewDialogReducer';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';

function ListView(props) {
	const table_name = "MODEL";
	const router = useRouter();
	const gridRef = useRef();
	const parentRef = useRef();
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	const skipHeader = [
		'category_name','category_id','dynamic_attribute',
		'dynamic_attribute_mapping','eol','eosl','id','image_link',
		'EOL_date','EOSL_date','image_name','manufacturer_name',
		'manufacturer_id','assets','model_id', 'category', 'manufacturer', 
		"entity_external_platform_id","original_info", "preview_image_link"
	]
	const [ windowHeight, setWindowHeight ]  = useState(window.innerHeight - 330);
	const [ openDeleteDialog, setOpenDeleteDialog ] = useState(false);
	const [ modelDetails, setModelDetails ] = useState({})
	const [ displayButton, setDisplayButton ] = useState(false);
	const [ loading, setLoading ] = useState(false);
	const [ categoryMenu, setCategoryMenu ] = useState([])
	const [ manufacturerMenu, setManufacturerMenu ] = useState([])
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [groupByArr, setGroupByArr] = useState([])
	const [tabValue, setTabValue] = useState(0)
	const [loadingActivityLog,setLoadingActivityLog] = useState(false);
	// const query_data = useSelector((state) => state.modelApp.filterParamsReducer);
	// const filterModel = useSelector((state) => state.modelApp.filterParamsReducer.filter);
	const query_data = useSelector(
    (state) => state.reportApp.reportViewDialogReducer.quick_filter
  );
	const tab_value = useSelector(
    (state) => state.reportApp.reportViewDialogReducer.tab_value
  );

	const handleClickOpen = () => {
		setOpenDeleteDialog(true);
	};

	const tableHeaders = [
		"model_no", "model_name", "category_", "manufacturer_", "size_no_of_assets", "description"
	];

	const handleClose = () => {
		setOpenDeleteDialog(false);
	};

	function handelEdit(data){
		dispatch(setFromData(data))
		dispatch(openFormViewerDialog())
	}

	function handleAddModel(){
		dispatch(openFormViewerDialog())
	}

	const handleDeleteDialogOpen = (data) => {
		handleClickOpen()
		setModelDetails(data)
	}

	function handelDelete(id){
		axios.delete(`/models/delete/${id}`).then((res)=>{
			if(res.status === 201){
				toast.error(res.data.message);
				handleClose()
			} else {
				toast.success(res.data.message)
				handleClose()
				props.refresh()
			}
		}).catch((err)=>{
			console.log('err',err.response);
			toast.error(err.response.data.message);
		})
	}

	function handelDeletev2(){
		if(modelDetails.id !== undefined) {
			axios.delete(`/models/delete/${modelDetails.id}`).then((res)=>{
				if(res.status === 201){
					toast.error(res.data.message);
					handleClose()
				} else {
					toast.success(res.data.message)
					handleClose()
					props.refresh()
				}
			}).catch((err)=>{
				console.log('err',err.response);
				toast.error(err.response.data.message);
			})
		}
		
	}

	function formatString(str){
			if(!str) return ''
			return str.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
	}

	const onGridReady = (params) => {
		gridRef.current = params
		setIsGridReady(isGridReady+1)
		props.endUsersAccounts.forEach((list) => {
			for(const [fieldName, value] of Object.entries(list)){
				if(value === '' || value === null) list[fieldName] = `No ${formatString(fieldName)}`
			}
		})
		if(router.query.report_name === undefined) {
			dispatch(setfilterlist({}));
			loadInitialState (params);
			dispatch(setrowGroupModel([]));
		}else{
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}
	
	function onFilterChanged(event){
		const rows = event.api.getFilterModel();
		dispatch(setfilterlist(rows));
		saveView("N/A", rows,gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

	function getReport(event){
		const {report_name} = router.query;
		const table_name = "model";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event?.api.applyColumnState({ state: row_model });
		})
		.catch(err=>{
			console.log(err);
		})
	}

	function loadInitialState (params){
		axios.get(`/user-view/show-view-order?table_name=${table_name}`)
		.then(results=>{
			const { data } = results.data;
			if(data !== null){
				const order = JSON.parse(data.order);
				const filter = JSON.parse(data.filter);
				gridRef.current.filterModelArr = filter
				params?.api.applyColumnState({ state: order });
				params.api.setFilterModel(filter);
			}
		})
		.catch(err=>{
			console.log(err);
		})
  }

	function saveView (rows, filter, filterModelArr=null){
		let payload = {}
		if(rows === 'N/A'){
			payload = {
				filter:  JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		}else{
			payload = {
				order:  JSON.stringify(rows),
				table_name
			}
		} 
		// const order = JSON.stringify(rows);
		axios.post('/user-view/save-view-order',payload)
		.then(()=>{
			console.log('view updated')
		})
		.catch(err=>{
			console.log(err);
		})
	}

	const onColumnMoved = (params) => {
		if(router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
			dispatch(setrowGroupModel(rows))
		}
	}

  function onColumnVisible(params){
		const rows = params.api.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
				saveView(params.api.getColumnState());
		}
	}
	function onSortChanged(params){
    if (router.query.report_name === undefined) {
      const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows));
      saveView(rows);
			dispatch(setrowGroupModel(rows))
    }
  }

  function onColumnRowGroupChanged(event) {
	  const api = event?.api;
	  if (!api) return;
	  const groupedColumns = api.getRowGroupColumns();
	  if (groupedColumns.length === 0) setGroupByArr([]);
	  else setGroupByArr(groupedColumns);

    if (router.query.report_name === undefined) {
      const rows = event.api.getColumnState();
		const first_row = rows[0];
      if (first_row.colId !== "ag-Grid-AutoColumn") {
        dispatch(setrowGroupModel(rows));
        saveView(rows);
      } else {
        dispatch(setrowGroupModel(rows));
      }
    }
    // auto size group columns
    // onRowGroupOpenedAutoSize();
  }

	const frameworkComponents = {
		customFilter: CustomFilter,
		// customDropdownEditor: CustomDropdownEditor
	};

	
	const onColumnPinned = (params) =>{
		if(router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView (rows);
			dispatch(setrowGroupModel(rows))
		}
	}

	function onCellValueChanged(e){
		let model_name = null
		let model_no = null
		let category = null
		let manufacturer = null
		let description = null
		if(e.colDef.field === "model_name"){
			model_name = e.newValue
		}
		// if(e.colDef.field === "manufacturer_"){
		// 	props.refresh()
		// 	return
		// }
		if(e.colDef.field === "model_no"){
			model_no = e.newValue
		}
		if(e.colDef.field === "category_"){
			category = categoryMenu.find(item=>item.label === e.newValue)
		}
		if(e.colDef.field === "manufacturer_"){
			manufacturer = manufacturerMenu.find(item=>item.label === e.newValue)
		}
		if(e.colDef.field === "description"){
			description = e.newValue
		}
		const payload = {
			id: e.data.id,
			entity_external_platform_id: e.data.entity_external_platform_id,
			model_no: e.data.model_no,
			model_name: e.data.model_name,
			category_id: category ? category.id : e.data.category.id ,
			manufacturer_id: manufacturer ? manufacturer.id : e.data.manufacturer.id,
			description: description ? e.data.description : e.data.original_info.description,
			eol_date :  e.data.eol === 'No Eol'? '': e.data.eol ? e.data.eol.split('T')[0] : '',
			eosl_date:  e.data.eosl === 'No Eosl'? '' : e.data.eosl ? e.data.eosl.split('T')[0] : '',
			image_link: e.data.original_info.image_link,
			image_name: e.data.original_info.image_name
		}
		if(!payload.model_no){
			toast.error('Model Number is required')
			props.refresh()
			return
		} if(!payload.model_name){
			toast.error('Model Name is required')
			props.refresh()
			return
		} if(!payload.category_id){
			toast.error('Category Name is required')
			props.refresh()
			return
		} if(!payload.manufacturer_id){
			toast.error('Manufacturer Name is required')
			props.refresh()
			return
		}
		axios.post('/models/update', payload).then(response => {
			if(response.status === 201){
				toast.error(response.data.message)
				props.refresh()
			} else {
				//   onSuccess()
				toast.success('Model updated Successfully.')
				props.refresh()
			}		  
		}).catch(err => {
		  console.log('212=>',err);
		//   toast.error('Something went wrong!')
		})
	}

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0 ;
		let startRowIndex = 0 ;
		let endRowIndex =  0 ;
		
		const rows = params.api.getCellRanges();

		if(rows.length != 0){
			columnCount = params.api.getCellRanges()[0].columns.length ;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex ;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex ;			
		}

		if(columnCount > 1 || startRowIndex != endRowIndex  ){
			setDisplayButton(true);
		}else{
			setDisplayButton(false);
		}
	}

	const generateHeaderLabel = (header) => {
		if(header === 'model_no'){
			return 'Model Number'
		}if(header === 'size_no_of_assets'){
			return 'Size No of Assets'
		}if(header.includes('_4o94ry')){
			return header.split('_4o94ry')[0]
		}
		return header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
	}

	useEffect(()=>{
		gridRef.current.api?.setQuickFilter(
			query_data
		);
	},[query_data])

	useEffect(() => {
		return () => {
				dispatch(setQuickFilter(null))
		}
	}, [])

	const fetchManufacturerSuggestions = () => {
		setLoading(true)
		let manufacturer = []
		axios.get("/manufacturers").then(response => {
			setLoading(false)
			manufacturer = AlphabeticalSorting(response.data.data,'manufacturer_name')
			setManufacturerMenu(manufacturer.map((item)=>{
				return{
					id: item.id,
					label: item.manufacturer_name
				}
			}))
		}).catch(err => {
			console.log('136=>',err);
			// toast.error('Something went wrong!')
		})
	}

	const fetchCategorySuggestions = () => {
		let category = []
		axios.get('/category?category_type=hardware').then(response => {
			category = AlphabeticalSorting(response.data.data,'category_name')
			setCategoryMenu(category.map((item)=>{
				return{
					id: item.id,
					label: item.category_name
				}
			}))
		}).catch(err => {
			console.log('164=>',err);
			// toast.error('Something went wrong!')
		})
	}

	const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

	function redirectToAssetProfile(event){
		if(event.value === 0){
      		return
    	}
		// localStorage.setItem('model_id',event.data.id)
		openInNewTab(`/assets-list?model_id=${event.data.id}`)
	}

	useEffect(()=>{
		fetchCategorySuggestions()
		fetchManufacturerSuggestions()
		// if(Object.keys(filterModel).length !== 0){
		// 	setTimeout(()=>{
		// 		gridRef.current.api.setFilterModel(filterModel);
		// 	},0)
		// }
	},[])

	const handleChildClick = (value) => {
		setTabValue(value)
  };

	// logs
	const [logs, setLogs] = useState([]);
	const [isGridReady, setIsGridReady] = useState(0)

	function formatLogs(data) {
    return data.map((item) => {
      return {
        id: item.id,
        action_id: `act${item.id}`,
        action_date_and_time: item.created_at,
        model_name: item?.model? `${item?.model.model_no}-${item?.model.model_name}`: item.model_name,
        name: item.user_name,
        action: item.action_name,
        description: item.comment,
        previous_value: item.previous_data,
        current_value: item.current_data,
        field_name: item.action_field_name,
        user_role: item.user_role_name,
      };
    });
  }

  function getLogs() {
		setLoadingActivityLog(true)
    axios
      .get("/models/activities")
      .then(({ data }) => {
				setLoadingActivityLog(false)
        setLogs(formatLogs(data.data.activities));
      })
      .catch((err) => {
				console.log(err)
        console.log("cannot fetch logs");
      })
  }

	useEffect(()=>{
		(tabValue === 1) && getLogs()
	},[tabValue])

	// const getValues = (status_name, row_id, column_name)=>{
	// 	let name = null;
	// 	name = manufacturerMenu.find(
	// 		(item) => item.label === status_name
	// 	);
	// 	if(!name) return
	// 	let payload = { manufacturer_id: name ? name.id : e.data.status.id,
	// 		model_id: parseInt(row_id)
	// 	}
	// 	axios.post(`/models/edit-manufacturer-in-model`, payload)
	// 	.then(results=>{
	// 		toast.success("Model updated successfully")
	// 		props.refresh();
	// 	})
	// 	.catch(err=>{
	// 		console.log(err);
	// 	})
	// }

	useEffect(()=>{
    setTabValue(tab_value)
  }, [tab_value])
	
  const handleAddReport = () => {
	dispatch(openReportViewerDialog())
}
	return (			
		<>
		{(tabValue === 0) && <AgGridFilterGroupView tableRef={gridRef} setRowGroupPanelShow={setRowGroupPanelShow}
				 groupByArrFromList ={ groupByArr }  parentRef = { parentRef } onClick={handleChildClick}
				 tableName= "Model" logs={logs} displayTableName = "Models" onClickAddButton={handleAddModel}
				 addPermission = {props.createModelPermission}
				 onClickAddReportButton={handleAddReport}
				key={isGridReady}
				/>}

		{(tabValue === 1) && (<ActivityAgGridListing module="Model" logs={logs} displayTableName = "Models"
		addPermission = {props.createModelPermission}
		loadingActivityLog={loadingActivityLog}
		/>)}

			{(tabValue === 0) && <div 
				className="ag-theme-alpine" 
				style={{
					width: "100%",
					height: windowHeight+105,
					fontSize: '12px'
				}}
			>
				<AgGridReact
					ref={gridRef}
                    theme="legacy"
					suppressRowClickSelection
					onGridReady={onGridReady}
					animateRows
					rowData={props.endUsersAccounts}
					rowHeight={30}
                    headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"
	
					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}
	
					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}
					groupHeaderHeight={1}
					floatingFiltersHeight={40}
					components={frameworkComponents}
	
					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{ statusPanel: 'agAggregationComponent' },
						],
					}}

					defaultColDef={{
						enableRowGroup: true,
						resizable: true
					}}
	
					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}
	
					onFilterChanged={onFilterChanged}
					autoGroupColumnDef={{ width: 150 }}
					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}
	
					cacheQuickFilter
					handleDeleteDialogOpen
					pagination
					columnDefs={[{
						lockPosition: true,
						rowSelection: "single",
						width: 100,
						minWidth: 100,
						maxWidth: 100,
						suppressSizeToFit: true,
						headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
						pinned: 'right',
						className: "action_field",
						lockPinned: true,
						cellRenderer: ({ data }) => {
							if (data) {
								return (
									<>
										{(props.updateModelPermission) &&
											<Tooltip id="edit" title="Edit" placement="top">
												{/* <Icon 
													onClick={() => handelEdit(data)} 
													style={{
														color: '#1d2939',
														paddingBottom: '3px',
														paddingRight:'30px',
														fontSize:'15px',
														cursor:'pointer'
													}}
												>
													edit
												</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-pencil" onClick={() => handelEdit(data)} />
											</Tooltip>
										}

										{(props.deleteModelPermission) &&
											<Tooltip id="delete" title="Delete" placement="top">
												{/* <Icon 
													onClick={() => handleDeleteDialogOpen(data)} 
													style={{
														color: '#1d2939',
														paddingBottom: '3px',
														paddingRight:'30px',
														fontSize:'15px',
														cursor:'pointer'
													}}
												>
													delete
												</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-trash" onClick={() => handleDeleteDialogOpen(data)} />
											</Tooltip>
										}
									</>
								)
							}
							return (<></>)
							
						}
					},
					...tableHeaders.filter((item) => !skipHeader.includes(item)).map((header) => {
						if (header === 'category_') {
							return {
								field: header,
								key: header,
								suppressSizeToFit: true,
								headerName: generateHeaderLabel(header),
								sortable: true,
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								filter: "agTextColumnFilter",
								flex: 1,
								minWidth: 200,
								editable: props.updateModelPermission,
								onCellValueChanged,
								cellEditorParams: { values: categoryMenu.map(category => category.label) },
								cellEditor: 'agRichSelectCellEditor',
							}
						}
						if (header === 'manufacturer_') {
							return {
								field: header,
								key: header,
								cellEditorPopup: true,
								sortable: true,
								filter: "agTextColumnFilter",
								flex: 1,
								minWidth: 200,
								suppressSizeToFit: true,
								editable: props.updateModelPermission,
								onCellValueChanged,
								headerName: generateHeaderLabel(header),
								cellEditorParams: {
									values: manufacturerMenu.map(manufacturer => manufacturer.label),
									// getValue: getValues
								},
								// cellEditor='customDropdownEditor'
								cellEditor: 'agRichSelectCellEditor',
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
							}
						}
						if (header === 'size_no_of_assets') {
							return {
								field: header,
								key: header,
								cellEditorPopup: true,
								sortable: true,
								filter: "agTextColumnFilter",
								flex: 1,
								minWidth: 200,
								suppressSizeToFit: true,
								headerName: generateHeaderLabel(header),
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								cellRenderer: (event) => {
									return (<a
										style={{
											height: '10px',
											width: '10px',
											color: 'black',
											cursor: 'pointer',
											marginTop: '2px',
											borderRadius: '50%',
											display: 'inline-block',
										}}
										onClick={() => redirectToAssetProfile(event)}
										variant="subtitle1"
									>
										<><span>{event.value}</span></>
									</a>)
								}
							}
						}
						if (header === 'source') {
							return {
								key: header,
								field: header,
								suppressSizeToFit: true,
								headerName: generateHeaderLabel(header),
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								sortable: true,
								filter: "agTextColumnFilter",
								flex: 1,
								minWidth: 200,
							}
						}
						return {
							key: header,
							field: header,
							suppressSizeToFit: true,
							editable: props.updateModelPermission,
							onCellValueChanged,
							headerName: generateHeaderLabel(header),
							headerComponent: (props) => (CustomFilter(props, header, gridRef)),
							sortable: true,
							filter: "agTextColumnFilter",
							flex: 1,
							minWidth: 200,
						}
					})]
					}
				/>
			</div>}
			{/* <DeleteModelDialog
				openDeleteDialog={openDeleteDialog}
				modelDetails={modelDetails}
				handelDelete={handelDelete}
				handleClose={handleClose}
			/> */}

			{
				openDeleteDialog && 

				<DeleteConfirmModal 
					openAlerModal={openDeleteDialog}
					module="Model"
					handleCloseAlertModal={handleClose} 
					handleAlertModal={handelDeletev2}
				/>
			}
		</>
	);
}

export default ListView

function DeleteModelDialog(props) {
	return (
		<div>
			<Dialog
				open={props.openDeleteDialog}
				onClose={props.handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					Delete Model
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<h4>Are you sure to delete this Model named as <b>{props.modelDetails.model_name}</b>?</h4>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={props.handleClose}>Cancel</Button>
					<Button onClick={() => props.handelDelete(props.modelDetails.id)} autoFocus>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}
